import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-062597f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.ellipsis && 'addressLabel', _ctx.$attrs.class || '']),
    title: _ctx.address
  }, [_createTextVNode(_toDisplayString(_ctx.address), 1)], 10, _hoisted_1)), [[_directive_loading, _ctx.loading]]);
}